import { useEffect, useState } from 'react';
import { PageHeader } from '@/components/layout/PageHeader';
import { StatCard } from '@/components/ui/StatCard';
import { projectsApi } from '@/api/projects.api';
import type { ProjectAnalytics } from '@/types/projects';
import { showApiError } from '@/utils/apiError';
import GroupsIcon from '@mui/icons-material/Groups';
import TimelineIcon from '@mui/icons-material/Timeline';
import AssignmentIcon from '@mui/icons-material/Assignment';

export function ProjectsWorkloadPage() {
  const [stats, setStats] = useState<ProjectAnalytics | null>(null);

  useEffect(() => {
    projectsApi.analyticsDashboard().then(setStats).catch((e) => showApiError(e, 'Analytics unavailable'));
  }, []);

  return (
    <div>
      <PageHeader title="Workload" description="Resource utilization and capacity planning"
        breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'Projects', to: '/projects' }, { label: 'Workload' }]} />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard title="Active projects" value={stats?.activeProjects ?? '—'} icon={<AssignmentIcon />} />
        <StatCard title="Task completion" value={stats ? `${stats.taskCompletionRate.toFixed(0)}%` : '—'} icon={<TimelineIcon />} />
        <StatCard title="Logged hours (month)" value={stats?.totalLoggedHours ?? '—'} icon={<GroupsIcon />} />
        <StatCard title="Sprint velocity" value={stats?.sprintVelocity ?? '—'} icon={<TimelineIcon />} />
      </div>
    </div>
  );
}
